import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { SupervisorPendingCall } from '@/models/callLog';

export const fetchSupervisorPendingCalls = async (): Promise<SupervisorPendingCall[]> => {
  const response = await queryExecute({
    query: graphql(`
      query SupervisorPendingCalls {
        supervisorPendingCalls {
          callerName
          callLogId
          callSid
          conferenceFriendlyName
          fromPhoneNumber
          toPhoneNumber
          operatorName
          priority
          purpose
          holdTime
        }
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.supervisorPendingCalls;
};
